import React from "react";
import "./HeroSection.css";
import mainimage from "../assets/mainimg.png";

export default function HeroSection() {
  return (
    <div id="herosectionclass" className="machinemainclass">
      <div className="left">
        <h1>Best Machine Learning Development Services in India</h1>
        <p>
         Partner with India’s trusted machine learning experts delivering 95% model accuracy and enterprise-grade solutions. As one of the best machine learning development services, we help businesses reduce manual efforts, optimize workflows, and accelerate digital transformation with proven ML strategies.
        </p>
      </div>
      <div className="right">
        <img src={mainimage} alt="error" />
      </div>
    </div>
  );
}
